const ROLE_TYPE = {
  subAccount: 0,
  primaryAccount: 1,
};
const USER_INFO = window.__USER_INFO__ || {};
const roleType = USER_INFO.roleType;

const ACCOUNT_STORAGE_KEY = 'ads_account_storage_key';
const userInfo = {
  get() {
    return (
      window.__USER_INFO__ || {
        username: 'unknown',
      }
    );
  },
  isLogged() {
    const { username } = this.get();
    return username && username !== 'unknown';
  },
  getAccountId() {
    return USER_INFO.newAccountId || USER_INFO.accountId;
  },
  getPrimaryAccountId() {
    return USER_INFO.primaryAccountId || USER_INFO.agcyId;
  },
  getSubAccountId() {
    return USER_INFO.subAccountId || USER_INFO.advId;
  },
  getAgencyId() {
    return USER_INFO.primaryAccountId || USER_INFO.agcyId;
  },
  getAdvId() {
    return USER_INFO.subAccountId || USER_INFO.advId;
  },
  getRoleType() {
    return roleType;
  },
  getBindRoles() {
    if (roleType === ROLE_TYPE.subAccount) {
      return [];
    } else if (roleType === ROLE_TYPE.primaryAccount) {
      return USER_INFO.bindAdvertisers || [];
    }
  },
  getBindSubAccount() {
    return USER_INFO.bindSubAccount || [];
  },
  confirmCurAccount(account) {
    if (account) {
      const bindAccounts = this.getBindSubAccount();
      const targetAccount = bindAccounts.find((item) => item.subAccountId === +account);
      if (targetAccount) {
        // 如果本地存在账户信息，且满足关联关系的要求，则以本地的账户信息为准
        window.__USER_INFO__.subAccountId = targetAccount.subAccountId;
        window.__USER_INFO__.advId = targetAccount.subAccountId;
        window.__USER_INFO__.newAccountId = targetAccount.oldAcountId;
        window.__USER_INFO__.accountId = targetAccount.oldAcountId;
        sessionStorage.setItem(ACCOUNT_STORAGE_KEY, account);
      }
    }
    localStorage.setItem(ACCOUNT_STORAGE_KEY, this.getSubAccountId());
    sessionStorage.setItem(ACCOUNT_STORAGE_KEY, this.getSubAccountId());
  },
};

const urlParam = new URLSearchParams(window.location.search);
if (urlParam.has('index')) {
  userInfo.confirmCurAccount(urlParam.get('index')); // 初始化，确定当前的账户信息
  urlParam.delete('index');
  window.history.replaceState(null, null, `?${urlParam.toString()}`);
} else {
  userInfo // 初始化，确定当前的账户信息
    .confirmCurAccount(
      sessionStorage.getItem(ACCOUNT_STORAGE_KEY) || localStorage.getItem(ACCOUNT_STORAGE_KEY),
    );
}

export default userInfo;
